import type { RouteRecordRaw } from 'vue-router'
import { getComponent } from '../utils'
import PublicLayout from '@/layouts/public-layout.vue'

export const public_routes: RouteRecordRaw[] = [
  {
    path: '/home',
    name: 'home',
    component: () => getComponent(`pages/home.vue`),
    meta: { title: () => 'Welcome', layout: PublicLayout, is_public: true }
  },
  {
    path: '/welcome',
    name: 'welcome',
    component: () => getComponent(`pages/welcome.vue`),
    meta: { title: () => 'Welcome', layout: PublicLayout, is_public: true }
  },
  {
    path: '/product',
    name: 'product',
    component: () => getComponent(`pages/product.vue`),
    meta: { title: () => 'Product', layout: PublicLayout, is_public: true }
  },
  {
    path: '/pricing',
    name: 'pricing',
    component: () => getComponent(`pages/pricing.vue`),
    meta: { title: () => 'Pricing', layout: PublicLayout, is_public: true }
  },
  {
    path: '/signup',
    name: 'auth-signup',
    component: () => getComponent(`pages/signup.vue`),
    meta: { title: () => 'Signup', layout: PublicLayout, is_public: true }
  },
  {
    path: '/login',
    name: 'auth-login',
    component: () => getComponent(`pages/login.vue`),
    meta: { title: () => 'Login', layout: PublicLayout, is_public: true }
  },
  {
    path: '/logout',
    name: 'auth-logout',
    component: () => getComponent(`pages/logout.vue`),
    meta: { title: () => 'Logout', layout: PublicLayout, is_public: true }
  },

  {
    path: '/demo-request',
    name: 'demo-request',
    component: () => getComponent(`pages/demo-request.vue`),
    meta: {
      title: () => 'Demo Request',
      layout: PublicLayout,
      is_public: true
    }
  },

  {
    path: '/docs',
    name: 'docs',
    component: () => getComponent(`pages/docs/index.vue`),
    meta: { title: () => 'Docs', layout: PublicLayout, is_public: true }
  }
]
